import {
    styled,
} from '@material-ui/core';
import BaseMadeByBoncos from 'components/made-by-boncos';


export const FormInnerContainer = styled(({...p}) =>
    <div {...p} />
)({
    width: '100%'
});

export const MadeByBoncos = styled(p=>
    <BaseMadeByBoncos {...p} />
)(({theme}) => ({
    marginTop: 'auto',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    textAlign: 'center',
}));